<template>
	<BaseWebshopAddToCartModal v-slot="{items, status, onClose, urls}" :auto-close="0">
		<div v-if="items?.length" class="add-to-cart-modal-container">
			<div class="modal-box dd">
				<BaseWebshopCart>
					<div @click="onClose" class="m-close-btn"></div>  
					<div v-if="status?.data?.label_name" class="message" :class="{'red': status?.data?.label_name == 'error_limitqty' || status?.data?.label_name == 'error_product_maximum_qty'}"><BaseCmsLabel :code='"modal_" + status.data.label_name' />{{status?.data?.label_name == 'error_product_maximum_qty' && status?.data?.maximum_qty ? status.data.maximum_qty + ' kom' : ''}}</div>
					<div class="modal-main-cnt">
						<div class="image">     
							<BaseUiImage loading="lazy" :data="items[0]?.main_image_thumbs['width300-height360']" default="/images/no-image-300.jpg" />
						</div> 
						<div class="desc">    
							<div class="content">     
								<p v-if="items[0].title" class="title">{{items[0].title}}</p>     
								<div v-if="items[0].code" class="modal-code">{{items[0].code}}</div>    
							</div>   
							<div class="modal-price-all">    
								<div v-if="items[0].price_custom" class="modal-price"><BaseUtilsFormatCurrency :price="items[0].price_custom" /></div> 
								<div v-if="items[0].extra_price_lowest && (items[0].discount_percent || items[0].discount_percent_custom) && items[0].extra_price_lowest != 0" class="modal-extra-price-lowest"><BaseCmsLabel code="extra_price_lowest" />: <BaseUtilsFormatCurrency :price="items[0].extra_price_lowest" /></div>
							</div> 
							<div class="modal-buttons clear">
								<NuxtLink class="btn btn-secondary btn-gray modal-view-cart" :to="urls.webshop_shopping_cart" @click="onClose()"><span><BaseCmsLabel code="view_shopping_cart" /></span></NuxtLink>							
							</div>
						</div>  
					</div>
					<div @click="onClose" class="close close-button"><span>Nastavi kupnju</span></div>  
				</BaseWebshopCart>
			</div>
			<div v-if="items?.length" class="modal-bg-close" @click="onClose"></div>
		</div>
	</BaseWebshopAddToCartModal>
</template>

<script setup>
	const labels = useLabels();
	const {onMediaQuery} = useDom();

	const {matches: mobileBreakpoint} = onMediaQuery({
		query: '(max-width: 980px)',
	});
</script>


<style lang="less" scoped>
	.add-to-cart-modal-container{position: fixed; left: 0; bottom: 0; top: 0; right: 0; background-color: rgba(30,8,49,0.3); z-index: 999999;}
	.modal-bg-close{position: absolute; left: 0; top: 0; bottom: 0; right:0; z-index: 1;}
	.modal-box{
		width: 775px; min-height: 365px; background: white; position: fixed; top: 20vh; left: 0; right: 0; margin: auto; z-index: 2; padding: 40px 50px 50px; box-shadow: 0 30px 40px 0 rgba(85,41,122,0.28); border-radius: var(--borderRadius);
		.message{
			font-weight: bold; font-size: 24px; color: var(--textColor); font-weight: 300; padding: 0px 80px 20px 44px; position: relative;
			&:before{ border-radius: var(--borderRadius); text-align: center; position: absolute; .icon-cart; font: 25px/25px var(--fonti); color: var(--primaryColor); left: 0; top: 4px;}
			&.red{
				color: var(--red); font-size: 18px; line-height: 22px; padding-top: 7px;
				&:before{background: var(--red); .icon-close; font-size: 15px; width: 30px; height: 30px; line-height: 30px; color: #fff; border-radius: 100%;}
			}
		}
		.title{font-size: 20px; line-height: 26px; padding-bottom: 0; color: var(--textColor); font-weight: 300; padding-bottom: 1px;}
		.close-button{
			width: auto; display: inline-flex; justify-content: center; align-items: center; height: auto; position: absolute; top: 50px; right: 60px; font-size: 14px; z-index: 99; cursor: pointer; font-size: 14px; line-height: 18px; color: var(--textColor); text-decoration: none; font-weight: normal;
			span{position: relative; padding-right: 11px;  
				&:before{position: absolute; .icon-bc; display: block; right: 0; top: 6px; font: 6px/6px var(--fonti); color: var(--primaryColor);}
			}
		}
		.image{ align-items: center; text-align: center; height: 200px; width: 235px; min-width: 235px; display: flex; flex-flow: column; justify-content: center;}
		:deep(img){width: auto; height: auto; max-width: 95%; max-height: 100%;}
		.desc{ flex-grow: 1; padding: 0 0 0 30px; display: flex; flex-flow: column; justify-content: space-between;}
		.content{padding-bottom: 12px;}
	}
	.m-close-btn{display: none;}

	.modal-main-cnt{display: flex; padding-top: 10px;}
	.modal-code{font-size: 14px; line-height: 18px; color: rgba(43,44,55,0.5);}
	.modal-price{font-size: 24px; line-height: 32px; font-weight: bold; color: var(--textColor);
		.cd-tax,.brand-logo,.cd-loyalty-save,.cd-brand-img,.cd-save,.cd-exchange-rate{display: none;}
		.cd-extra-price-lowest{font-weight: normal;}
		.cd-double-prices{display: flex; flex-flow: unset;}
		.cd-current-price{font-size: 24px; line-height: 30px;
			ins{display: inline-block !important; padding: 0 1px 0 6px;}
		}
	}
	.modal-old-price{display: block; text-decoration: line-through; font-size: 12px; line-height: 15px; font-weight: normal; color: var(--textColor);}
	.modal-buttons{
		padding: 15px 0 0; display: flex; font-size: 0;
		.btn{min-width: 200px; width: 200px; line-height: 58px; color: var(--primaryColor); margin-bottom: 0; border: 1px solid var(--primaryColor); font-size: 18px;
			@media(min-width: @h){
				&:hover{color: white; background: #4D256F; border-color: 0 !important}
			}
		}
	}
	.modal-extra-price-lowest{font-size: 14px; line-height: 18px; color: #98989F; padding-top: 3px;}	
	.modal-view-cart{background: white; border: 1px solid var(--borderColor); margin-right: 10px;}

	@media (max-width: @t){
		.modal-box{
			width: 640px; min-height: 305px; padding: 30px 38px 38px; 
			.message{
				font-size: 22px; padding: 0 100px 20px 40px;
				&:before{font: 22px/22px var(--fonti); top: 4px;}
			}
			.close-button{top: 40px; right: 50px; font-size: 12px; line-height: 16px; 
				span{padding-right: 10px;
					&:before{top: 4px; font: 6px/6px var(--fonti);}
				}
			}
			.image{width: 160px; height: 175px; min-width: 160px;}
			.desc{padding: 0 0 0 30px;}
			.title{font-size: 18px; line-height: 23px; padding-bottom: 1px;}
			.content{padding-bottom: 10px;}
		}
		.modal-code,.modal-old-price{font-size: 12px; line-height: 16px;}
		.modal-price{font-size: 22px; line-height: 30px;}
		.modal-buttons{
			.btn{min-width: 180px; width: 180px; line-height: 50px; font-size: 16px; height: 50px;}
		}		
	}
	@media (max-width: @m){
		.modal-box{
			padding: 15px 15px 22px; position: absolute; top: auto; left: 0; right: 0; bottom: 0; background: white; width: auto; min-height: auto; border-radius: 0; text-align: center; box-shadow: 0px -5px 20px rgba(85, 41, 122, 0.5);
			.message{
				font-size: 18px; line-height: 22px; padding: 0 36px; display: flex; justify-content: center; font-weight: 400; 
				&.red{
					padding-top: 4px; padding-left: 40px;
					&:before{flex: 0 0 30px;}
				}
				&:before{font: 20px/20px var(--fonti); position: static; margin: 0 10px 0 0;}
			}
			.image{width: 170px; height: 170px; min-width: 170px; margin: 0 auto;}
			.desc{padding: 0;}
			.title{font-size: 16px; line-height: 21px; padding: 0 10px 6px; font-weight: 400;}
			.close-button{
				font-size: 16px; line-height: 21px; position: static; text-decoration: underline; margin-top: 14px; color: var(--primaryColor); 
				span{
					padding-right: 0;
					&:before{display: none;}
				}
			}
			.content{padding-bottom: 8px;}
		}
		.modal-code{font-size: 14px;}
		.modal-main-cnt{position: relative; padding-top: 15px; display: block;}
		.modal-price{font-size: 18px; line-height: 24px;
			.cd-price{padding-right: 0;}
			.cd-current-price{font-size: 18px; line-height: 24px;
				ins{padding: 0 0 0 4px;}
			}
		}
		.modal-buttons{
			padding: 16px 0 0;
			.btn{width: 100%; min-width: 100%; line-height: 50px; font-size: 16px; height: 50px; margin: 0;  color: #fff; border: 0;}
		}
		.modal-view-cart{background: #2EC4B6;}
		.modal-extra-price-lowest{padding-top: 0; font-size: 12px; line-height: 16px;}
		.m-close-btn{
			display: block; position: absolute; top: 12px; right: 15px; width: 28px; height: 28px; border-radius: 2px; background: var(--primaryColor); z-index: 99;
			&:before, &:after{ .pseudo(14px,2px); top: 13px; left: 7px; background: #fff; .rotate(45deg);}
			&:after{.rotate(-45deg);}
		}
	}

</style>